import type { ApiClient } from "@/modules/core/api/client/apiClient"
import { TransactionDtoSchema, type TransactionDto } from "@/modules/finances/gateway/transactionDto"
import type { PaymentToValidateFilterStatus } from "@/modules/finances/types/financesType"
import { PaymentsToValidateColumnToSort } from "@/modules/finances/utils/financeUtils"
import { ColumnSortingOrder } from "@/modules/types/datatableTypes"
import { toPage, type Paginated } from "@/modules/utils/paginated"

export enum PaymentsToValidateEnumApi {
  OWNER = "OWNER",
  ATHLETE = "ATHLETE",
}

export class PaymentsToValidateApi {
  private baseBoxUrl = "/box/financial/transactions"
  private baseAtheleUrl = "/financial/transactions"

  constructor(private api: ApiClient) {}

  private getBaseUrl = (api: PaymentsToValidateEnumApi) => {
    switch (api) {
      case PaymentsToValidateEnumApi.OWNER:
        return this.baseBoxUrl
      case PaymentsToValidateEnumApi.ATHLETE:
        return this.baseAtheleUrl
    }
  }

  async getPaymentsToValidate(
    api: PaymentsToValidateEnumApi,
    filter: PaymentToValidateFilterStatus | undefined,
    nameFilter: string | undefined,
    page: number,
    size?: number,
    sortBy: PaymentsToValidateColumnToSort = PaymentsToValidateColumnToSort.DATE,
    sortOrder: ColumnSortingOrder = ColumnSortingOrder.DESC,
  ) {
    const result = await this.api.get<Paginated<TransactionDto>>(`${this.getBaseUrl(api)}/to-validate`, {
      params: { page, size, sort: `${sortBy},${sortOrder}`, search: nameFilter, status: filter },
    })

    const pageData = toPage(result.data)

    return {
      ...pageData,
      content: pageData.content.map((transaction) => {
        const result = TransactionDtoSchema.safeParse(transaction)
        if (!result.success) {
          throw new Error(`Invalid transaction content: ${JSON.stringify(result.error)}`)
        }
        return result.data
      }),
    }
  }

  async abandonPayment(api: PaymentsToValidateEnumApi, transactionId: string) {
    await this.api.post(`${this.getBaseUrl(api)}/${transactionId}/abandon`)
  }
}
